import { lazy, Suspense, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AiOutlineMessage } from "react-icons/ai";
import ChatBot from "./Components/ChatBot/ChatBot";
import { Context } from "./Context/ContextProvider";
import { getList } from "./ConfigFiles/SharedFunctions";
import { urls } from "./ConfigFiles/Consts";
import { getUserfromSS } from "./ConfigFiles/SmallFunctions";
import { sidenavbars } from "./SharedComponents/NewNavBarConst";
// import "./Bootstrap/css/bootstrap.min.css"

const Login = lazy(() => import("./Components/Authentication/Login"));
const PatientRegister = lazy(() => import("./Components/Authentication/PatientRegistration"));
const BookAmbulance = lazy(() => import("./Components/Authentication/BookAmbulance"));
const AccessLinksNotAssigned = lazy(() => import("./Components/Authentication/AccessLinksNotAssigned"));
const CreatePassword = lazy(() => import("./Components/Authentication/CreatePassword"));
const RoutingConfig = lazy(() => import("./Components/RoutingConfig"));
const PrivateRoute = lazy(() => import("./PrivateRoutes/PrivateRoute"));
const Privacy = lazy(() => import("./Components/Authentication/Privacy"));
const AppointmentDetails = lazy(() => import("./Components/Servicemanagement/Models/AppointmentDetails"));
const PatientConsent = lazy(() => import("./Components/Servicemanagement/Models/PatientConcent"));
const AppointmentFeedback = lazy(() => import("./Components/Servicemanagement/Appointments/Modals/Feedbackform"));
const TermsAndConditions = lazy(() => import("./Components/Authentication/TermsAndConditions"));
const App = () => {
  // const language = useSelector((state) => state.language);
  const { language } = Context();
  const [isRtl, setIsRtl] = useState(false);
  const { t, i18n } = useTranslation();

  // const changeLanguage = (lng) => {
  //   lng == "Arabic" ? setIsRtl(true) : setIsRtl(false);
  //   i18n.changeLanguage(lng);
  // };
  const changeLanguage = (lng) => {
    lng == "Arabic" ? setIsRtl(true) : setIsRtl(false);
    // i18n.changeLanguage(lng);
  };

  function getActiveLinks(links) {
    return links
      .filter((link) => link.status === "Active")
      .map((link) => ({
        linkName: link.linkName,
        accessLinkId: link.accessLinkId,
      }))
      .concat(links.filter((link) => link.child).flatMap((link) => getActiveLinks(link.child)));
  }

  const getAccessLinks = async () => {
    let res1 = await getList(urls?.UserGroups?.GetAllAccessLinksByUser, {});
    let links = getActiveLinks(res1)?.map((e) => e?.linkName);
    let accessLinkIds = getActiveLinks(res1)?.map((e) => e?.accessLinkId);
    sessionStorage.setItem("accessLinks", JSON.stringify(links));
    sessionStorage.setItem("accessLinkIds", JSON.stringify(accessLinkIds));
  };

  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  const currentPath = window?.location.pathname;

  const filterRoutes = (routes, filteredData) => {
    return routes
      ?.filter((route) => filteredData?.includes(route.linkName) || (route.child && route.child.some((child) => filteredData?.includes(child.linkName))))
      ?.map((route) => {
        if (route.child) {
          route.child = filterRoutes(route.child, filteredData);
        }
        return route;
      });
  };
  const filteredRoutes = filterRoutes(sidenavbars, JSON?.parse(sessionStorage?.getItem("accessLinks")));
  const getRoutes = (data) => data?.flatMap(({ route, child }) => (route ? [route] : child ? getRoutes(child) : []));
  let isValidateRoute = getRoutes(filteredRoutes)?.some((e) => e == currentPath?.split("/").slice(0, 4).join("/"));
  // //console.log(isValidateRoute, "IDVVA")
  // if (!isValidateRoute) {
  //   sessionStorage.clear(); // Clear session if no match

  // } else {

  // }

  useEffect(() => {
    getUserfromSS("userId") > 0 && getAccessLinks();
  }, []);

  return (
    <div style={{ direction: isRtl ? "rtl" : "ltr", backgroundColor: "#f6f7fa" }}>
      {/* <div onClick={handleParentClick}> */}
      <Suspense fallback={() => <div>Loading ....</div>}>
        <Router>
          <Routes>
            <Route path="*" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/accessLinksNotAssigned" element={<AccessLinksNotAssigned />} />
            <Route path="/pramotion" element={<Login />} />
            <Route path="/register" element={<PatientRegister />} />
            <Route path="/bookambulance" element={<BookAmbulance />} />
            <Route path="*" element={<Login />} />
            <Route path="/createpassword/:token" element={<CreatePassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/appointmentDetails/:id" element={<AppointmentDetails />} />
            <Route path="/feedback/:id" element={<AppointmentFeedback />} />
            <Route
              path="v1/*"
              element={
                <PrivateRoute>
                  <RoutingConfig rtl={isRtl} />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </Suspense>
      {/* </div> */}
      {/* <div className="chatbot-button ">
        <AiOutlineMessage
          onClick={() => setIsChatbotOpen(!isChatbotOpen)}
          size={30}
        />
        {isChatbotOpen && <ChatBot />}
      </div> */}
    </div>
  );
};

export default App;
